import { ChangeDetectionStrategy,Component, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatOption } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatError, MatFormField, MatHint, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';

import { FilterCategory, LocalFilterDefinition, RemoteFilter } from 'app/shared/graph';
import { TranslatableLabelFieldComponent } from 'app/shared/store-locales/translatable-label-field.component';

export interface EditFilterCategoryDialogData {
    mode: 'create' | 'edit';
    storeId: string;
    supportedLocales: string[];
    labelTranslations?: Record<string, string>;
    filterBuiltIn: LocalFilterDefinition[];
    remoteFilters: RemoteFilter[];
    filterCategory: FilterCategory;
    filterCategories: Array<FilterCategory>;
}

export interface EditFilterCategoryDialogResult {
    id?: string;
    label: string;
    labelTranslations: Record<string, string>;
    builtInFilter: string[];
    remoteFilters: string[];
}

@Component({
    selector: 'admin-edit-filter-category.component',
    templateUrl: './edit-filter-category-dialog.component.html',
    styleUrls: ['./edit-filter-category-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogTitle, MatDialogContent, FormsModule, MatFormField, MatLabel, MatSelect, ReactiveFormsModule, MatOption, MatDialogActions, MatButton, MatDialogClose, TranslatableLabelFieldComponent, MatError, MatHint, MatInput],
})
export class EditFilterCategoryDialogComponent {
    dialogRef = inject<MatDialogRef<EditFilterCategoryDialogComponent>>(MatDialogRef);
    readonly data = inject<EditFilterCategoryDialogData>(MAT_DIALOG_DATA);

    public filterCategoryInfo: EditFilterCategoryDialogResult;
    public storeId: string;
    label: string;
    builtInFilters = new FormControl();
    remoteFilters = new FormControl();
    IsValid = true;

    constructor() {
        const data = this.data;

        if (data.filterCategory) {
            this.filterCategoryInfo = {
                id: data.filterCategory.id,
                label: data.filterCategory.label,
                labelTranslations: data.labelTranslations ?? {},
                builtInFilter: [],
                remoteFilters: [],
            };
            this.builtInFilters.setValue(data.filterCategory.builtInFilters);
            this.remoteFilters.setValue(data.filterCategory.remoteFilters.map(rf => rf.id));
        } else {
            this.filterCategoryInfo = {
                label: '',
                labelTranslations: {},
                builtInFilter: [],
                remoteFilters: [],
            };
        }
    }

    verifyKeyUnicity(event: string) {
        if (this.data.mode === 'create') {
            this.IsValid = this.data.filterCategories.findIndex(x => x.label == event) == -1;
        } else {
            this.IsValid = this.data.filterCategories.findIndex(x => x.label == event && x.id != this.data.filterCategory.id) == -1;
        }
    }

    valid() {
        this.filterCategoryInfo.builtInFilter = this.builtInFilters.value;
        this.filterCategoryInfo.remoteFilters = this.remoteFilters.value;
        this.dialogRef.close(this.filterCategoryInfo);
    }
}
